/**
 * 普通编辑器按钮工厂
 * 2018-1-2
 * Bai.Zhiming
 */
'use strict';
angular.module('ueditorBtnServiceModule', []).factory('ueditorBtnService', [
    '$q',
    'localStorageService',
    'ueditorService',
    'trsUploadAVNewService',
    'modalDialog',
    'editingCenterService',
    'editCenUploadVideoForXjService',
    '$sessionStorage',
    '$timeout',
    'publicToolService',
    function ($q, localStorageService, ueditorService, trsUploadAVNewService, modalDialog, editingCenterService, editCenUploadVideoForXjService, $sessionStorage, $timeout, publicToolService) {

        /**
         * [insertFinish description]
         * @param   {[object]}  UE    [UE description]
         * @param   {[object]}  ue    [ue description]
         * @param   {[number]}  i     [i description]
         * @param   {[string]}  type  [type description] 活动和广告区别
         * @return  {[type]}          [return description]
         */
        function insertFish(UE, ue, i, type) {
            var defer = $q.defer();
            var btn = {
                index: i,
                obj: '',
            };
            UE.registerUI(type, function (editor, uiName) {
                editor.registerCommand(uiName, {
                    execCommand: function () {
                        ue = ue ? ue : UE.getEditor('ueditor');
                        let htmlContent = ue.getContent();
                        let reg = /finish-flag/;
                        if (reg.test(htmlContent)) {
                            return;
                        }
                        var htmlTemplate = ['<p>', '<span class="finish-flag">（完）</span>', '</p>'].join('');
                        htmlContent += htmlTemplate;
                        ue.execCommand('cleardoc');
                        ue.execCommand('insertHtml', htmlContent);
                        ue.fireEvent('contentchange');
                    },
                });
                btn.obj = new UE.ui.Button({
                    // 按钮的名字
                    name: type,
                    // 提示
                    title: type,
                    // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                    cssRules:
                        type === '插入完结' ? 'background-image: url(lib/ueditor2/themes/default/images/finish.png) !important;background-repeat:no-repeat;background-size: 100% 100%;' : 'background-image: url(lib/ueditor2/themes/default/images/finish.png) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                    // 点击时执行的命令
                    onclick: function () {
                        editor.execCommand(uiName);
                    },
                });
                defer.resolve(btn);
                return btn.obj;
            });
            return defer.promise;
        }

        /**
         * [inserAudio description] 插入音频
         * @param   {[type]}  UE     [UE description]
         * @param   {[type]}  ue     [ue description]
         * @param   {[type]}  i      [i description]
         * @param   {[type]}  type   [type description]
         * @param   {[type]}  scope  [scope description]
         * @return  {[type]}         [return description]
         */
        function inserAudio(UE, ue, i, type, scope) {
            var defer = $q.defer();
            var btn = {
                index: i,
                obj: '',
            };
            UE.registerUI(type, function (editor, uiName) {
                editor.registerCommand(uiName, {
                    execCommand: function () {
                        ueditorService.basicUploadAudio(UE, ue);
                    },
                    // execCommand: function() {},
                });
                btn.obj = new UE.ui.Button({
                    // 按钮的名字
                    name: type,
                    // 提示
                    title: type,
                    // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                    cssRules:
                        'background-image: url(lib/ueditor2/themes/default/images/editor-for-yinpin.png) !important;background-repeat:no-repeat;background-size: 100% 100%;background-position: 0px 0px !important',
                    // 点击时执行的命令
                    onclick: function () {
                        editor.execCommand(uiName);
                    },
                });
                if ((scope.type !== undefined || scope.draftType !== 'video') && scope.type !== 'newsPaper') {
                    defer.resolve(btn);
                    return btn.obj;
                } else {
                    defer.reject();
                }
                // defer.resolve(btn);
                // return btn.obj;
            });
            return defer.promise;
        }

        return {

            /**
             * [pagebreak description]
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            pagebreak: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('pagebreak', function (editor, uiName) {
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            ue.execCommand('insertHtml', '<hr ispageseparator="true"/>');
                            ue.fireEvent('contentchange');
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        name: 'pagebreak',
                        title: '插入分页',
                        cssRules: 'background-position: -460px -40px;',
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.type === 'website') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [restoreLocalVersion description] 恢复本地版本
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            restoreLocalVersion: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI(
                    'button',
                    function (editor, uiName) {
                        // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                        editor.registerCommand(uiName, {
                            execCommand: function () {
                                scope.type = scope.type === undefined ? 'iwo' : scope.type;
                                var flag = false;
                                var content = '';
                                var storage = localStorageService.get('ueLocalVersion');
                                if (storage !== null) {
                                    for (var i = 0; i < storage.length; i++) {
                                        if (storage[i][scope.type + '_ID'] === scope.list.METADATAID + '') {
                                            content = storage[i].CONTENT;
                                            flag = true;
                                            break;
                                        }
                                    }
                                }
                                if (flag) {
                                    modalDialog.alertType('确定恢复未保存的稿件正文至编辑区？', '', 'ask', true, function () {
                                        ue.setContent(content);
                                    });
                                } else {
                                    modalDialog.alertType('没有未保存的稿件正文', '', 'info', false);
                                }
                            },
                        });

                        // 创建一个button
                        btn.obj = new UE.ui.Button({
                            // 按钮的名字
                            name: '恢复本地版本',
                            // 提示
                            title: '恢复本地版本',
                            // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                            cssRules: 'background-position: -559px -39px;',
                            // 点击时执行的命令
                            onclick: function () {
                                // 这里可以不用执行命令,做你自己的操作也可
                                editor.execCommand(uiName);
                            },
                        });
                        if (scope.type !== undefined || scope.draftType !== 'video') {
                            defer.resolve(btn);
                            return btn.obj;
                        } else {
                            defer.reject();
                        }
                    } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/
                );
                return defer.promise;
            },

            /**
             * [insertVideo description] 插入视频
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertVideo: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                // 插入视频开始 ---start
                UE.registerUI('button2', function (editor, uiName) {
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            trsUploadAVNewService.openVideoModal().then(function (data) {
                                for (var i = 0; i < data.html.length; i++) {
                                    if (data.html[i].videoHtml) {
                                        var dom = document.createElement('div');
                                        dom.innerHTML = data.html[i].videoHtml;
                                        ue = ue ? ue : UE.getEditor('ueditor');
                                        ue.execCommand('inserthtml', dom.innerHTML);
                                    }
                                }
                                ue.fireEvent('contentChange');
                                ue.focus();
                                // scope.$emit('examineVideo',data.data);
                            });
                        },
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入视频',
                        // 提示
                        title: '插入视频',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -321px -140px;',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });

                    // 因为你是添加button,所以需要返回这个button
                    if ((scope.type !== undefined || scope.draftType !== 'video') && scope.type !== 'newsPaper' && scope.draftType !== 'headline') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
                // 插入视频结束 ---end
            },

            /**
             * [insertImage description] 插入图片
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertImage: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('插入图片', function (editor, uiName) {

                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () { },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入图片',
                        // 提示
                        title: '插入图片',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -726px -78px;',
                        // 点击时执行的命令
                        onclick: function () {
                            ueditorService.basicUploadPic('picture').then(function (data) {
                                ueditorService.insertImages(data).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                        },
                    });
                    if (scope.type !== 'newsPaper') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertCloudPlateFlag description] 云平台组件
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertCloudPlateFlag: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                var insertCloudPlateFlag = false;
                UE.registerUI('云平台组件', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            ueditorService.cloudPlate();
                            scope.$on('insertCloudPlate', function (event, value) {
                                if (insertCloudPlateFlag) {
                                    return;
                                }
                                insertCloudPlateFlag = true;
                                setTimeout(function () {
                                    ue.execCommand('insertHtml', value);
                                    ue.fireEvent('contentchange');
                                    insertCloudPlateFlag = false;
                                }, 500);
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '云平台组件',
                        // 提示
                        title: '云平台组件',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/cloudPlate.png) !important;background-repeat:no-repeat',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.type === 'weixin') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [insertInternalLink description] 插入内链
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertInternalLink: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('插入内链', function (editor, uiName) {
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            ueditorService.insertInternalLink().then(function (result) {
                                ue.execCommand('insertHtml', result);
                                ue.fireEvent('contentchange');
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '插入内链',
                        // 提示
                        title: '插入内链',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/internalLink.png) !important;background-repeat:no-repeat',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (scope.type === 'website') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [multiImgsWaterLink description] 批量水印
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @param   {[type]}  media  [media description]
             * @return  {[type]}         [return description]
             */
            multiImgsWaterLink: function (UE, scope, ue, i, media) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                UE.registerUI('批量水印', function (editor, uiName) {
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            var reg = /[^\\\/]*[\\\/]+/g;
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var dom = $(ue.body);
                            var imgs = $(dom).find('img');
                            var sendList = [];
                            var check = 'FileName';
                            for (var i = 0; i < imgs.length; i++) {
                                if ($(imgs[i]).attr('videoid')) {
                                    continue;
                                }
                                var checkList = imgs[i].src.split(/[? = & \s+]/);
                                var index = checkList.indexOf(check);
                                let picUrl = $(imgs[i]).attr('src');
                                let tmp = {
                                    APPFILE: index === -1 ? picUrl.replace(reg, '') : checkList[index + 1],
                                    PERPICURL: picUrl,
                                };
                                sendList.push(tmp);
                            }
                            ueditorService.multiImgsWaterLink(sendList).then(function (result) {
                                for (var i = 0; i < imgs.length; i++) {
                                    if ($(imgs[i]).attr('videoid')) {
                                        imgs[i].src = $(imgs[i]).attr('_src');
                                        continue;
                                    }
                                    let picUrl = $(imgs[i]).attr('src');
                                    var checkList = picUrl.split(/[? = & \s+]/);
                                    var index = checkList.indexOf(check);
                                    var find = '';
                                    if (index !== -1) {
                                        find = checkList[index + 1];
                                    } else {
                                        find = picUrl.replace(reg, '');
                                    }
                                    // imgs[i].src = result.LIST[find] && result.LIST[find].FILEURL;
                                    if (result.LIST[find]) {
                                        imgs[i].src = result.LIST[find] && result.LIST[find].FILEURL;
                                    }
                                }
                                ue.setContent($(ue.body).html());
                            });
                        },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '批量水印',
                        // 提示
                        title: '批量水印',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/shuiyin.png) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                        // 点击时执行的命令
                        onclick: function () {
                            editor.execCommand(uiName);
                        },
                    });
                    if (media && media !== 'newspaper' && media !== 'iwo') {
                        // if (media && (media === 'website' || media === 'app')) {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },

            /**
             * [aKeyComposing description] 一键排版
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @param   {[type]}  media  [media description]
             * @return  {[type]}         [return description]
             */
            aKeyComposing: function (UE, scope, ue, i, media) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                // 插入视频开始 ---start
                UE.registerUI('一键排版', function (editor, uiName) {
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                        },
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: '一键排版',
                        // 提示
                        title: '一键排版',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules:
                            'background-image: url(lib/ueditor2/themes/default/images/pai.svg) !important;background-repeat:no-repeat;background-size: 100% 100%;',
                        // 点击时执行的命令
                        onclick: function () {
                            var ueExample = ue ? ue : UE.getEditor('ueditor');
                            ueditorService.autotypesetFun(ueExample, media);
                        },
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;
            },

            /**
             * [insertActivity description] 插入完结
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertFinish: function (UE, scope, ue, i) {
                return insertFish(UE, ue, i, '插入完结');
            },

            /**
             * [UE description]
             * @param   {[type]}  UE     [UE description]
             * @param   {[type]}  scope  [scope description]
             * @param   {[type]}  ue     [ue description]
             * @param   {[type]}  i      [i description]
             * @return  {[type]}         [return description]
             */
            insertAudio: function (UE, scope, ue, i) {
                return inserAudio(UE, ue, i, '插入音频', scope);
            },

            /**
             * [insertAttachment description] 插入附件
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertAttachment: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: '',
                };
                let mediaName = editingCenterService.getMediaName(editingCenterService.getEditPageMediaType());
                let docType = editingCenterService.getDocType(editingCenterService.getDocTypeId);
                if (docType !== '新闻' || mediaName !== '网站') {
                    defer.reject();
                    return defer.promise;
                }
                UE.registerUI('插入附件', function (editor, uiName) {
                    // 插入组件功能
                    // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () { },
                    });
                    btn.obj = new UE.ui.Button({
                        // 按钮的名字
                        name: 'attachment',
                        // 提示
                        title: '插入附件',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'attachment',
                        // 点击时执行的命令
                        onclick: function () {
                            if (scope.insertDisable === true) {
                                modalDialog.alertType('禁止在此处插入附件', '', 'warning', false);
                                return; // 如果是在导语内部，则不允许再插入导语
                            }
                            ueditorService.uploadAttachment().then(function (data) {
                                ueditorService.insertAttachment(data).then((dom) => {
                                    ue = ue ? ue : UE.getEditor('ueditor');
                                    ue.execCommand('inserthtml', dom);
                                    ue.fireEvent('contentChange');
                                });
                            });
                        },
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;

            },

            /**
             * [insertAttachment description] 插入文本转音频
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertTextToAudio: function (UE, scope, ue, i) {
                let defer = $q.defer();
                publicToolService.getModeconfiguration('editorWordToAudio').then((config) => {
                    if (config && config.shield === true) {
                        defer.resolve();
                    } else {
                        let btn = {
                            index: i,
                            obj: '',
                        };
                        let mediaName = editingCenterService.getMediaName(editingCenterService.getEditPageMediaType());
                        let docType = editingCenterService.getDocType(editingCenterService.getDocTypeId);
                        if (docType !== '新闻' || mediaName !== 'I我') {
                            defer.reject();
                            return defer.promise;
                        }
                        UE.registerUI('唱校功能', function (editor, uiName) {
                            // 插入组件功能
                            // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                            editor.registerCommand(uiName, {
                                execCommand: function () { },
                            });
                            btn.obj = new UE.ui.Button({
                                // 按钮的名字
                                name: 'attachment',
                                // 提示
                                title: '唱校功能',
                                // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                                cssRules:
                                    'background-image: url(lib/ueditor2/themes/default/images/yuyin.png) !important;background-repeat:no-repeat;background-size: 100% 100%;background-position: 0px 0px !important',
                                // 点击时执行的命令
                                onclick: function () {
                                    let content;
                                    const user = $sessionStorage.get('curUserInfo');
                                    if (!user) {
                                        modalDialog.alertType('错误', '没有找到当前登录用户信息', 'error', false);
                                        return;
                                    }
                                    const tenantId = user.TENANTID;
                                    const userToken = $sessionStorage.cookie.get('userToken');
                                    if (!userToken) {
                                        modalDialog.alertType('错误', '当前用户没有权限', 'error', false);
                                        return;
                                    }
                                    const curRange = ue.selection.getRange();
                                    const userId = userToken.token;
                                    if (!ue.getContent()) {
                                        modalDialog.alertType('错误', '编辑器内没有文本', 'error', false);
                                        return;
                                    }
                                    if ($('#wordToAudioPlayerBox').length) {
                                        $('#wordToAudioPlayer')[0].pause();
                                        $('#wordToAudioPlayerBox').remove();
                                    }
                                    if (curRange.collapsed) {
                                        content = ue.getContentTxt();
                                    } else {
                                        content = curRange.cloneContents().textContent;
                                    }
                                    const commanParams = {
                                        speaker: 'kangge',
                                        tenantId,
                                        userId,
                                    };
                                    const registerParams = angular.extend({
                                        content,
                                    }, commanParams);
                                    let getInfoParams;
                                    scope.$parent.loadingPromise = editCenUploadVideoForXjService.registerWordToAudio(registerParams)
                                        .then((data) => {
                                            if (data.datas.audioid) {
                                                getInfoParams = angular.extend({
                                                    audioId: data.datas.audioid,
                                                }, commanParams);
                                                wordToAudioTimeout(scope, getInfoParams);
                                            }
                                        });
                                },
                            });
                            defer.resolve(btn);
                            return btn.obj;
                        });
                    }
                });

                return defer.promise;

            }

        };

        /**
         * [wordToAudioTimeout 获取文本转音频结果]
         *
         * @param   {[type]}  scope  [params description]
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function wordToAudioTimeout(scope, params) {
            const timeOutId = scope.$parent.loadingPromise = $timeout(function () {
                scope.$parent.loadingPromise = editCenUploadVideoForXjService.getAudioInfo(params).then(
                    function (data) {
                        if (data.datas.status !== 1) {
                            // 1表示转码完成
                            wordToAudioTimeout(scope, params);
                        } else {
                            createAudioPlayerForWord();
                            $('#wordToAudioPlayer').attr('src', data.datas.audiourl);
                            $('#wordToAudioPlayer')[0].play();
                        }
                    },
                    function (error) {
                        if (error.code && error.code !== '500') {
                            modalDialog.alertType('转换失败', error.msg, 'warning', false);
                        }
                        $timeout.cancel(timeOutId);
                    }
                );
            }, 3000);
        }

        /**
        * [createAudioPlayerForWord 创建文字转语音播放器]
        *
        * @return  {[type]}      [return description]
        */
        function createAudioPlayerForWord() {
            const boxHeight = 60;
            const audioDom = `
            <div id="wordToAudioPlayerBox" draggable="true" style="position: fixed; left: 0px; bottom: 50px; z-index: 1050; height: ${boxHeight}px; overflow:hidden;">
                <div id="closeWordToAudioPlayerBtn" style="width:20px; height: 20px; text-align: center; line-height:20px; position:absolute; right:9px; top:2px; z-index:1051; cursor:pointer; background:#333; color:#fff;clip-path: circle();"><i>X</i></div>
                <audio controls="controls" src="" id="wordToAudioPlayer"></audio>
            </div>
                `;
            $('body').append(audioDom);
            $('#closeWordToAudioPlayerBtn').on('click', function () {
                $('#wordToAudioPlayer')[0].pause();
                $('#wordToAudioPlayerBox').remove();
            });
            var distance;
            var lastLocation;
            $('#wordToAudioPlayerBox').on('dragstart', function (e) {
                distance = {
                    left: e.originalEvent.offsetX,
                    top: e.originalEvent.offsetY,
                };
                lastLocation = {
                    left: e.originalEvent.clientX,
                    top: e.originalEvent.clientY,
                };
                e.originalEvent.dataTransfer.effectAllowed = 'all';
            });
            $('#wordToAudioPlayerBox').on('drag', function (e) {
                $(this).css('visibility', 'hidden');
            });
            $('#wordToAudioPlayerBox').on('dragend', function (e) {
                const editorFramePosition = $('.edui-editor-iframeholder')[0].getBoundingClientRect();
                const bodyRect = $('body')[0].getBoundingClientRect();
                let left;
                let top;
                // 编辑器内不允许放置，如果拖拽到编辑器范围内，则本次拖拽无效，恢复到拖拽前的位置
                if (e.originalEvent.screenX - distance.left > editorFramePosition.left && e.originalEvent.screenX - distance.left + $(this).width() < editorFramePosition.right && e.originalEvent.screenY - distance.top > editorFramePosition.top && e.originalEvent.screenY - distance.top + boxHeight < editorFramePosition.bottom) {
                    top = lastLocation.top;
                    left = lastLocation.left;
                } else {
                    top = e.originalEvent.clientY - distance.top;
                    left = e.originalEvent.clientX - distance.left;
                }
                if (top < bodyRect.top) {
                    top = 0;
                }
                if (top + boxHeight > bodyRect.bottom) {
                    top = bodyRect.bottom - boxHeight;
                }
                if (left < bodyRect.left) {
                    left = 0;
                }
                if (left + $(this).width() > bodyRect.right) {
                    left = bodyRect.right - $(this).width();
                }
                $(this).css('left', left + 'px');
                $(this).css('top', top + 'px');
                $(this).css('visibility', 'visible');
            });
            $('body').on('dragover', function (e) {
                e.originalEvent.preventDefault();
                e.originalEvent.dataTransfer.dropEffect = 'move';
            });
        }
    },
]);

